import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TreeContent from './TreeContent';
import TreeIcon from './TreeIcon';
import TreeTrigger from './TreeTrigger';

function Tree(props) {
	const {showIcon, icon, trigger, content, open, defaultOpen, disabled, onClick} = props;

	const [isOpened, setIsOpened] = useState(open ? open : defaultOpen);

	return (
		<StyledTree className="tree customScrollbar">
			<TreeTrigger onClick={onClick} isOpened={isOpened} setIsOpened={setIsOpened} disabled={disabled}>
				{showIcon && <TreeIcon icon={icon} isOpened={isOpened} disabled={disabled} />}
				<section className="tree-trigger-children">{trigger}</section>
			</TreeTrigger>
			{isOpened && <TreeContent>{content}</TreeContent>}
		</StyledTree>
	);
}

Tree.propTypes = {
	open: PropTypes.bool,
	defaultOpen: PropTypes.bool,
	onClick: PropTypes.func
};

Tree.defaultProps = {
	showIcon: true,
	open: false,
	defaultOpen: false
};

const StyledTree = styled.section`
	overflow-y: overlay !important;
	overflow-x: hidden !important;
`;

export default Tree;
